import { Typography } from '@mui/material';

import { REQUIRED_INDICATOR_CLASS_NAME } from '../../constants';
import { FORTA_ERROR, FORTA_GRAY5 } from '../../../../utils/colors';

import type { RequiredIndicatorProps } from './types';

export default function RequiredIndicator({ hasHelperText, error, sx }: RequiredIndicatorProps) {
  return (
    <Typography
      className={REQUIRED_INDICATOR_CLASS_NAME}
      variant="caption"
      component="span"
      sx={[
        (theme) => ({
          position: 'absolute',
          pointerEvents: 'none',
          right: theme.spacing(1.75),
          bottom: hasHelperText ? theme.spacing(2) : theme.spacing(-0.75),
          zIndex: 1,
          lineHeight: 1.2,
          px: 0.5,
          fontSize: '0.75rem',
          letterSpacing: 0.02,
          color: error ? FORTA_ERROR : FORTA_GRAY5,
          bgcolor: 'background.paper',
        }),
        ...(sx == null ? [] : Array.isArray(sx) ? sx : [sx]),
      ]}
    >
      Required
    </Typography>
  );
}
